import { basePath } from 'src/components/AppRoutes/Enterprise/EnterpriseBasePath';

const base = `${basePath}/corps`;

export const CorporatePaths = {
  base,
  create: `${base}/create`,
  edit: `${base}/:corpid`,
};
